const initialState = [
  {
    getCatchUpData: [],
    isCatchUpLoading: false,
  },
];

const catchupReducer = (state = initialState, action) => {
  switch (action.type) {
    case "CATCHUP_DATA":
      return {
        ...state,
        getCatchUpData: action.payload,
      };
    case "LOADING_START_CATCHUP":
      return {
        ...state,
        isCatchUpLoading: true,
      };
    case "LOADING_END_CATCHUP":
      return {
        ...state,
        isCatchUpLoading: false,
      };
    default:
      return state;
  }
};

export default catchupReducer;
